import React, { useEffect, useRef, useState } from 'react'
import './AnalogClock.css'

const paddy = (num) => {
  return (""+num).padStart(2,'0');
}

export default function AnalogClock() {
  const canvasRef = useRef(null);
  const analogFont = '8px Verdana';   // '14px Verdana';
  const digitalFont = '8px Arial';  // '14px Arial';
  const digitalColor = '#c8ff00';
  const innerColor = 'blue';
  const [sizeIx, setSizeIx] = useState(3);
  const sizeList = [48, 80, 96, 128, 146]; // Perfect: 128; (old 172;)  no digits: 86;
  
  const clockSize = sizeList[sizeIx]; 
  
  const clckClick = (e) => {
    setSizeIx(prev => (prev+1)%sizeList.length);
  }

  useEffect(() => {
    let flip = false;
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const radian = Math.PI/180;
  
    const radius = canvas.width / 2;
    const centerX = canvas.width / 2;
    const centerY = canvas.height /2;
    const sA = 0.16;
   
    // ARROW
    const arrow = (ctx, angle, len, arrowSpan, color) => {
      const size = len/100*radius;
      const arrowPeak = 0.82 * size;
      const leftAngle = angle - arrowSpan;
      const rightAngle = angle + arrowSpan;

      ctx.beginPath();
      moveToStart(ctx, angle);
      ctx.lineTo(centerX + Math.sin(leftAngle) * arrowPeak, centerY - Math.cos(leftAngle) * arrowPeak);
      ctx.lineTo(centerX + Math.sin(angle) * size, centerY - Math.cos(angle) * size);
      ctx.lineTo(centerX + Math.sin(rightAngle) * arrowPeak, centerY - Math.cos(rightAngle) * arrowPeak);
      ctx.lineTo(centerX + Math.sin(angle) * (sA*radius), centerY - Math.cos(angle) * (sA*radius));
      ctx.closePath();

      ctx.lineWidth = 1;
      ctx.strokeStyle = color;
      ctx.fillStyle = color;
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(centerX, centerY, sA*radius, angle + (Math.PI/2) - 0.1, angle + (Math.PI/2) +0.1);
      ctx.lineWidth = 8;
      ctx.stroke();
    }

    const moveToStart = (ctx, angle) => {
      ctx.moveTo(centerX + Math.sin(angle) * (sA*radius), centerY - Math.cos(angle) * (sA*radius)); 
    }
  
    //---[ DRAW CLOCK ]---
    const drawClock = () => {
      // Clear the canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      if (clockSize > 100) {
        hourNumbers();
      }

      if (clockSize > 45) {
        dots();
      }

      // Calculate angles for the hour and minute lines
      const now = new Date();
      let H = now.getHours();
      let M = now.getMinutes();
      const S = now.getSeconds();
      const hourAngle = ( H%12  +  M/60 ) * 30 * radian;
      const minuteAngle = ( M + S/60 ) * 6 * radian;
      const secondsAngle = ( S + now.getMilliseconds()/1000) * 6 * radian;

      innerCircle();      
      
      
      arrow(ctx, minuteAngle,   86, 0.060,  '#e68e23');
      arrow(ctx, hourAngle,     62, 0.120,  '#8b1414');
      arrow(ctx, secondsAngle,  98, 0.001,  '#82bdcc');

      if (clockSize > 100) {
        digitalClock();
      }

      // ---[  Functions  ]---

      function hourNumbers() {
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.fillStyle = '#03192e';
        ctx.fill();
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#246';
        ctx.stroke();


        for (let h = 0; h < 12; ++h) {
          const hTagAng = h * 30 * radian;

          const sX = centerX + Math.sin(hTagAng) * (0.8 * radius);
          const sY = centerY - Math.cos(hTagAng) * (0.8 * radius);

          ctx.beginPath();
          ctx.font = analogFont;
          ctx.fillStyle = '#fff';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          let dH = h;
          if (h === 0) {
            dH = 12;
          }
          ctx.fillText(dH.toString(), sX, sY);
        }
      }

      function digitalClock() {
        const digitalTime = `${paddy(H)} ${paddy(M)}`;
        ctx.beginPath();
        
        ctx.fillStyle = digitalColor;
        ctx.font = digitalFont;
        ctx.fillText(digitalTime, clockSize / 2, clockSize / 3);
        
        ctx.stroke();

        flip = !flip;
        if (flip) {
          ctx.beginPath();
          ctx.fillText(':', clockSize / 2, clockSize / 3);
          ctx.stroke();
        }
        else {
        }
      }

      function innerCircle() {
        ctx.beginPath();
        ctx.arc(centerX, centerY, 0.05 * radius, 0, 2 * Math.PI);
        ctx.lineWidth = 2;
        ctx.strokeStyle = innerColor;
        ctx.stroke();
      }

      function dots() {
        for (let d = 0; d < 12; d = d + 1) {
          const dAng = d / 12 * 2 * Math.PI;
          const start = 0.96 * radius;
          const end = 0.99 * radius;

          ctx.beginPath();
          ctx.moveTo(centerX + Math.sin(dAng) * start, centerY - Math.cos(dAng) * start);
          ctx.lineTo(centerX + Math.sin(dAng) * end, centerY - Math.cos(dAng) * end);
          ctx.lineWidth = 1;
          ctx.strokeStyle = '#aaaaaa';
          ctx.stroke();
        }
      }
    };
    
    const ticky = setInterval(drawClock, 1000);

    return () => {
      clearInterval(ticky);
    };

  }, [sizeIx, clockSize]);

  return (
    <div className='analogClock'>
      <canvas ref={canvasRef} width={clockSize} height={clockSize} onClick={clckClick}/>
    </div>
  )
}
